<template>
  <div>
      <b-modal v-bind="$attrs" v-on="$listeners" v-model="modalShow" hide-footer hide-header>
          <div class="d-block text-center">
              <img src="/images/icon-error.svg">
              <p class="modal-title mb-2">{{ Message }}</p>
              <button class="btn btn-modal-close" @click="modalShow = false">閉じる</button>
          </div>
      </b-modal>
    <div class="overlay" id="loading" v-if="loadingShow">
        <div class="text-center loadingSpinner">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
    </div>
  </div>
</template>
.success-modal{
  .content{
    width: 80%;
    height: 220px;
    max-width: 380px;
  }
}
<style>
    .overlay {
        background: rgba(0, 0, 0, 0.5) !important;
        z-index: 101 !important;
    }
    .modal-content {
        margin: 33% auto 0 auto !important;
        padding-top: 48px;
        width: 90%;
        max-width: 380px;
        height: 303px;
        background: #fff;
        border-radius: 20px;
        filter: drop-shadow(0px 0px 10px rgba(38, 99, 152, 0.02));
        text-align: center;
    }
    .modal-body {
        padding: 0 48px;
    }
    .modal-title {
        margin-top: 23px;
        font-family: "Hiragino Sans";
        font-weight: bold;
        font-size: 18px;
        color: #485258;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
    }
    .d-block {
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
    }
    .modal-error-message {
        margin-top: 5px;
        margin-bottom: 28px;
        height: 34px;
        font-family: "Hiragino Sans";
        font-weight: bold;
        font-size: 13px;
        line-height: 20px;
        text-align: left;
        color: #485258;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
    }
    .btn-modal-close {
        width: 71px;
        height: 31px;
        font-family: "Hiragino Sans";
        font-weight: normal;
        font-size: 13px;
        color: #6f8591;
        border-color: #6f8591;
    }
    .loadingSpinner {
        margin-top: 25% !important;
    }
</style>
<script>
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Vue from 'vue/dist/vue.esm.js';
Vue.use(BootstrapVue);

  export default {
    data() {
      return {
        modalShow: false,
        loadingShow: false,
        Caution: '',
        Message: ''
      }
    },
    methods: {
        setMessage(caution, message) {
            this.Caution = caution;
            this.Message = message;
            this.modalShow = !this.modalShow
        },
        loading(load) {
            this.loadingShow = load;
        },
    },
  }
</script>
